import React, { useState, useRef, useEffect, useCallback } from 'react'
import { useNavigate, useParams, useLocation } from 'react-router-dom'
import { ApplyPcContent, ErrorPopup, Footer, ServiceList, SuccessPopup, TermsPopup } from '../../common'
import { useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import * as yup from 'yup'
import { deliveryAppConfig } from '../../configs/deliveryApp'
import { images } from '../../../assets'
import ConnectStatus from "./ConnectStatus";
import { checkCorporateRegiNumber } from '../../tools'
import { applyConfig } from '../../configs'

const AppFood = () => {
  const navi = useNavigate()
  const location = useLocation()
  const param = useParams()
  const formRef = useRef()

  const [btnState, setBtnState] = useState(false) // 시작 예상
  const [bodyScrollY, setBodyScrollY] = useState(0) // 스크롤값을 저장하기 위한 상태
  const [deliveryApps, setDeliveryApps] = useState([]);
  const [bizNoTrue, setBizNoTrue] = useState(false)
  const [bizNoHelper, setBizNoHelper] = useState()

  const defaultDeliveryApps = [{
    "shop_idx": '',
    "app_idx": '',
    "app_type_code": '01',
    "app_name": '배민',
    "app_id": '',
    "connection_yn": ''
  }, {
    "shop_idx": '',
    "app_idx": '',
    "app_type_code": '02',
    "app_name": '요기요',
    "app_id": '',
    "connection_yn": ''
  }, {
    "shop_idx": '',
    "app_idx": '',
    "app_type_code": '03',
    "app_name": '쿠팡',
    "app_id": '',
    "connection_yn": ''
  }];

  const handleFollow = () => {
    setBodyScrollY(window.pageYOffset) // window 스크롤 값을 bodyScrollY 저장
  }
  useEffect(() => {
    const watch = () => {
      window.addEventListener('scroll', handleFollow)
    }
    watch() // addEventListener 함수를 실행
    return () => {
      window.removeEventListener('scroll', handleFollow) // addEventListener 함수를 삭제
    }
  })
  //신청서 유효성 검사
  const formSchema = yup.object({
    app_id_01: yup
      .string()
      .required('필수정보입니다.'),
    app_id_02: yup
      .string()
      .required('필수정보입니다.'),
    app_id_03: yup
      .string()
      .required('필수정보입니다.'),
    app_password_01: yup
      .string()
      .required('필수정보입니다.'),
    app_password_02: yup
      .string()
      .required('필수정보입니다.'),
    app_password_03: yup
      .string()
      .required('필수정보입니다.')
  })

  const {
    register,
    handleSubmit,
    setValue,
    getValues,
    watch,
    reset,
    formState: { errors }
  } = useForm({
    mode: 'onChange',
    resolver: yupResolver(formSchema),

    defaultValues: {
      'app_change_01': false,
      'app_change_02': false,
      'app_change_03': false,
      'app_id_01': '1',
      'app_id_02': '2',
      'app_id_03': '3',
      'app_password_01': '*********',
      'app_password_02': '*********',
      'app_password_03': '*********',
    }
  })

  function inputChecked(e, id) {
    setValue(id, e.target.checked);
    if (e.target.checked === true) {
      e.target.parentNode.parentNode.classList.add('isOpen')
    } else {
      e.target.parentNode.parentNode.classList.remove('isOpen')
    }
  }
  const verifyBizNo = useCallback(() => {
    console.log('verifyBizNo')  //remove this log
    const bizNo = window.document.getElementById('biz_no').value.replace(/-/g, '')

    // 사업자번호 체크 (사업자번호, 예금주 사업자번호)
    if (checkCorporateRegiNumber(bizNo) === false) {
      setBizNoHelper('사업자번호를 검증해주세요')
      return
    }

    if (bizNo.length === 10 || bizNo.length === 14) {
      const data = {
        biz_no: bizNo,
        shop_code: param.shop_code
      }
      applyConfig
        .verifyBizNoShopCode(data)
        .then(result => {
          if (result.shop_name !== null && result.shop_name !== undefined) {
            setBizNoHelper('')
            setBizNoTrue(true)
            setValue('shop_name', result.shop_name);
          }
          else {
            setBizNoHelper('사업자번호를 확인해 주세요.')
            setBizNoTrue(false)
          }
        })
        .catch(error => {
          alert(error);
        })
    }
  }, [])
  const getListApp = () => {
    deliveryAppConfig.getListApp(param.shop_code)
      .then(result => {
        for (var i = 0; i < 3; i++) {
          var app = result.data.find(e => e.app_type_code === defaultDeliveryApps[i].app_type_code);
          if (app !== undefined) {
            defaultDeliveryApps[i] = app;
          }
          else {
            defaultDeliveryApps[i].shop_idx = result.data[0]?.shop_idx
          }
        }
        setDeliveryApps(defaultDeliveryApps);
        defaultDeliveryApps.forEach(e => {
          if (e.app_id !== '') {
            setValue(`app_id_${e.app_type_code}`, e.app_id);
          }
          else {
            setValue(`app_id_${e.app_type_code}`, '');
            setValue(`app_password_${e.app_type_code}`, '');
          }
          
        });
        var btnState = !defaultDeliveryApps.some(e => e.app_id !== '' && e.connection_yn === 'N');
        setBtnState(btnState);

      }
      )
      .catch(error => alert(error.message))
  }
  useEffect(() => {
    getListApp();
  }, [])
  const onChangeBizNo = e => {
    let text = e.target.value
    if (text.length > 10 && text.indexOf('-') < 0) {
      text = text.slice(0, 10) + '-' + text.slice(10);
    }
    text = text
      .replace(/[^0-9.-]/g, '')
      .replace(/(\..*?)\..*/g, '$1')
      .replace(/^0[^.]/, '0');
    console.log('onChangeBizNo', text)
    setValue(
      'biz_no',
      text
    )
    setBizNoTrue(false)
  }
  const handleQuit = () => {
    window.close();
  }
  const handleSaveApps = (item) => {
    var appChangeCode = item.app_type_code;
    var data = [{
      app_idx: item.app_idx,
      app_id: getValues(`app_id_${appChangeCode}`),
      app_password: getValues(`app_password_${appChangeCode}`),
      app_type_code: appChangeCode,
      shop_idx: item.shop_idx
    }]
    deliveryAppConfig.updateApps(data)
      .then(result => {
        if (result.data.data.connectAppCnt > 0) {
          alert('계정 정보가 수정되었어요!');
        }
        else {
          alert('배달 앱 연동에 실패했어요.\r\n계정 정보를 다시 한번 확인해 주세요.');
        }
        getListApp();
      }
      )
      .catch(error => alert(error.message))
  }
  return (
    <div className="Application SubPages">
      <div className="application_wrap">
        <ApplyPcContent /> {/* 1024 이상 display */}
        <div className={'application_sheet 2'} ref={formRef}>
          <div className={bodyScrollY < 276 ? 'main_wrap' : 'main_wrap scroll'}>
            <div className="header">
              <div className="logo_brg"></div>
              {!location?.state?.isMain && (
                <div className="env_state">
                  {process.env.REACT_APP_NODE_ENV === 'development' ? '[개발서버] ' : ''}
                </div>
              )}
            </div>
            <h1>
              스폰지R <br /> 계정정보  수정하기
            </h1>
            <p className="main_subtit">스폰지R 서비스는 소중한 고객이 작성한 배달앱 리뷰를 위탁 관리하는 서비스입니다.</p>
          </div>

          <div className="service_wrap">
            <p className="wrap_tit">
              배달앱 계정 정보 변경
            </p>
            <div className="customer_box" style={{ marginTop: "30px" }}>
              <label htmlFor="biz_no">사업자 등록번호</label>
              <div className="input_btn_box">
                <input
                  type="text"
                  name="biz_no"
                  id="biz_no"
                  {...register('biz_no', { onChange: e => onChangeBizNo(e) })}
                  className={errors.biz_no ? 'error' : ''}
                  autoComplete="off"
                />
                <button type="button" className={'btn_style ' + (bizNoHelper ? 'error' : '')}
                  onClick={() => verifyBizNo()}>
                  사업자 번호 확인
                </button>
              </div>
              <p className="caution color_r">{bizNoHelper ? bizNoHelper : errors.biz_no && errors.biz_no.message}</p>
              <div className="customer_box">
                <label htmlFor="shop_name">사업자 상호</label>
                <input
                  type="text"
                  name="shop_name"
                  id="shop_name"
                  {...register('shop_name')}
                  autoComplete="off"
                  readOnly={true}
                />
                <p className="caution">예&#41; 멕시카나 연남점</p>
              </div>
            </div>
            {bizNoTrue ?
              <div>
                <p className="wrap_tit">
                  배달앱 계정
                </p>
                {deliveryApps?.map((item, i) => (
                  <div className="service_box" key={item.app_type_code}>
                    <div className="service_check">
                      <label htmlFor={`${item?.app_type_code}`}>
                        <div className="service_logo">
                          <Img code={item.app_type_code} />
                          <p style={{ marginRight: '7px' }}>{item?.app_name}</p>
                          <ConnectStatus status={item?.connection_yn} />
                        </div>
                      </label>
                      <input disabled={item.connection_yn === 'Y'} style={{ visibility: 'hidden' }} type="checkbox" name="service_division" id={`${item?.app_type_code}`} onChange={e => inputChecked(e, `app_change_${item?.app_type_code}`)} autoComplete="off" />
                      <label class={item.connection_yn === 'Y' || item.connection_yn === 'N' ? 'modify-btn' : 'label_img w_60'} htmlFor={`${item?.app_type_code}`}></label>
                    </div>
                    <div className="service_account">
                      <button onClick={() => handleSaveApps(item)} type="button" className="btn_default btn_save_app_food" >
                        검증
                      </button>
                      <div>
                        <label htmlFor={`app_id_${item?.app_type_code}`}>아이디</label>
                        <input
                          type="text"
                          name={`app_id_${item?.app_type_code}`}
                          id={`app_id_${item?.app_type_code}`}
                          onChange={() => { }}
                          {...register(`app_id_${item?.app_type_code}`)}
                          autoComplete="off"
                        />
                        <p className="caution">{errors[`app_id_${item?.app_type_code}`] && errors[`app_id_${item?.app_type_code}`].message}</p>
                        <label htmlFor={`app_password_${item?.app_type_code}`}>비밀번호</label>
                        <input
                          type="password"
                          name={`app_password_${item?.app_type_code}`}
                          id={`app_password_${item?.app_type_code}`}
                          {...register(`app_password_${item?.app_type_code}`)}
                          onChange={() => { }}
                          autoComplete="off"
                        />
                        <p className="caution">{errors[`app_password_${item?.app_type_code}`] && errors[`app_password_${item?.app_type_code}`].message}</p>
                      </div>
                    </div>
                  </div>
                ))
                }

                <div className="submit_wrap">
                  <p>
                    본 서비스 신청과 관련하여 서비스 내용, 출금 정보, 이용 약관을 충분히 숙지하고, 하이픈코퍼레이션 CMS 자동이체를 신청하기 위해 금융거래
                    정보 제공 및 개인정보의 수집, 이용, 개인정보 제3자 제공에 동의하며. 이에 본 서비스를 신청합니다.
                  </p>
                  <button
                    onClick={handleQuit}
                    type="button"
                    className="btn_default"
                    disabled={!btnState}
                  >
                    계정정보 변경 완료하기
                  </button>
                </div>
              </div>
              : ''
            }
          </div>

          {/* 푸터내용 */}
          <Footer />

        </div>
      </div>
    </div>
  )
}

export { AppFood }
const Img = ({ code }) => {
  switch (code) {
    case '01':
      return <img src={images.logoBaemin} alt="logoBaemin" />
    case '02':
      return <img src={images.logoYogiyo} alt="logoYogiyo" />
    case '03':
      return <img src={images.logoCoupang} alt="logoCoupang" />
    default:
      return
  }
}